module.exports = __webpack_public_path__ + "img/barcode-reader.ef7d2965.svg";